import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:3000';

const holidayDateAPI = axios.create({
  baseURL: `${API_BASE_URL}/holiday-date`,
  timeout: Number(process.env.REACT_APP_API_TIMEOUT) || 10000,
  headers: {
    'Content-Type': 'application/json',
  },
});

holidayDateAPI.interceptors.response.use(
  (response) => response,
  (error) => {
    console.error('Holiday Date Service Error:', error);
    return Promise.reject(error);
  }
);

export const holidayDateService = {
  getAll: async () => {
    try {
      const response = await holidayDateAPI.get('/');
      return response.data;
    } catch (error) {
      throw new Error('Error al obtener los feriados: ' + error.message);
    }
  },
};

export default holidayDateService;
